export default __webpack_public_path__ + "static/media/first-right-img-2x.0f360f32.png";